/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/light";

const $root = ($protobuf.roots.open || ($protobuf.roots.open = new $protobuf.Root()))
.addJSON({
  proto: {
    options: {
      go_package: ".;proto"
    },
    nested: {
      TSOPAIServiceCategoryInfo: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          categoryID: {
            type: "int32",
            id: 2
          },
          isRelated: {
            type: "bool",
            id: 3
          },
          enName: {
            type: "string",
            id: 4
          }
        }
      },
      TSOPAIServiceAppraisalKindsRequest: {
        fields: {}
      },
      TSOPAIServiceAppraisalKindsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          kindInfos: {
            rule: "repeated",
            type: "TSOPAIServiceCategoryInfo",
            id: 3
          }
        }
      },
      TSOPAIServiceAppraisalBrandsRequest: {
        fields: {
          kindID: {
            type: "int32",
            id: 1
          }
        }
      },
      TSOPAIServiceAppraisalBrandsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          brandInfos: {
            rule: "repeated",
            type: "TSOPAIServiceCategoryInfo",
            id: 3
          }
        }
      },
      TSOPAIServiceAppraisalSeriesRequest: {
        fields: {
          brandID: {
            type: "int32",
            id: 1
          }
        }
      },
      TSOPAIServiceAppraisalSeriesResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          seriesInfos: {
            rule: "repeated",
            type: "TSOPAIServiceCategoryInfo",
            id: 3
          }
        }
      },
      TSOPAIServicePointInfo: {
        fields: {
          necessity: {
            type: "bool",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          pointId: {
            type: "int32",
            id: 3
          },
          photoGuide: {
            type: "string",
            id: 4
          },
          exampleImg: {
            type: "string",
            id: 5
          },
          stickFigureImg: {
            type: "string",
            id: 6
          },
          bigStickFigureImg: {
            type: "string",
            id: 7
          }
        }
      },
      TSOPAIServiceAppraisalPointsRequest: {
        fields: {
          hierarchy: {
            type: "int32",
            id: 1
          },
          ID: {
            type: "int32",
            id: 2
          }
        }
      },
      TSOPAIServiceAppraisalPointsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          pointInfos: {
            rule: "repeated",
            type: "TSOPAIServicePointInfo",
            id: 3
          }
        }
      },
      TSOPUploadImageRequest: {
        fields: {
          imgB64: {
            type: "string",
            id: 1
          }
        }
      },
      TSOPUploadImageResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          imageUrl: {
            type: "string",
            id: 3
          }
        }
      },
      TSOPMyRecordListRequest: {
        fields: {
          apiCategory: {
            type: "string",
            id: 1
          },
          status: {
            type: "int32",
            id: 2
          },
          startTime: {
            type: "int64",
            id: 3
          },
          endTime: {
            type: "int64",
            id: 4
          },
          pageSize: {
            type: "uint32",
            id: 5
          },
          pageNum: {
            type: "uint32",
            id: 6
          },
          kindId: {
            type: "int32",
            id: 7
          }
        }
      },
      TSOPMyRecordListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          myRecordList: {
            rule: "repeated",
            type: "MyRecordItem",
            id: 3
          },
          totalCount: {
            type: "int64",
            id: 4
          }
        },
        nested: {
          MyRecordItem: {
            fields: {
              ID: {
                type: "uint32",
                id: 1
              },
              time: {
                type: "int64",
                id: 2
              },
              apiCategory: {
                type: "string",
                id: 3
              },
              kind: {
                type: "string",
                id: 4
              },
              brand: {
                type: "string",
                id: 5
              },
              series: {
                type: "string",
                id: 6
              },
              status: {
                type: "int32",
                id: 7
              },
              requestID: {
                type: "string",
                id: 8
              },
              mainPic: {
                type: "string",
                id: 9
              },
              productName: {
                type: "string",
                id: 10
              },
              degree: {
                type: "string",
                id: 11
              },
              oaid: {
                type: "string",
                id: 12
              },
              userImage: {
                type: "string",
                id: 13
              },
              reportURL: {
                type: "string",
                id: 14
              },
              verifyCategory: {
                type: "int32",
                id: 15
              },
              verifyResult: {
                type: "int32",
                id: 16
              },
              verifyComment: {
                type: "string",
                id: 17
              },
              suspectAreas: {
                type: "string",
                id: 18
              }
            }
          }
        }
      },
      TSOPAppraisalSingleItem: {
        fields: {
          imageUrl: {
            type: "string",
            id: 1
          },
          pointName: {
            type: "string",
            id: 2
          },
          grade: {
            type: "int32",
            id: 3
          }
        }
      },
      TSOPAppraisalDetailRequest: {
        fields: {
          oaid: {
            type: "string",
            id: 1
          },
          appraisalType: {
            type: "TSOPAppraisalType",
            id: 2
          }
        }
      },
      TSOPAppraisalDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          status: {
            type: "bool",
            id: 3
          },
          kindName: {
            type: "string",
            id: 4
          },
          brandName: {
            type: "string",
            id: 5
          },
          seriesName: {
            type: "string",
            id: 6
          },
          appraisalTime: {
            type: "string",
            id: 7
          },
          result: {
            type: "string",
            id: 8
          },
          grade: {
            type: "string",
            id: 9
          },
          description: {
            type: "string",
            id: 10
          },
          saList: {
            rule: "repeated",
            type: "TSOPAppraisalSingleItem",
            id: 11
          },
          requestID: {
            type: "string",
            id: 12
          },
          mappingResult: {
            type: "string",
            id: 13
          }
        }
      },
      TSOPNewOrOldDetailItem: {
        fields: {
          pointName: {
            type: "string",
            id: 1
          },
          imageUrl: {
            type: "string",
            id: 2
          }
        }
      },
      TSOPNewOrOldDetailRequest: {
        fields: {
          ID: {
            type: "int32",
            id: 1
          }
        }
      },
      TSOPNewOrOldDetailResponse: {
        fields: {
          requestID: {
            type: "string",
            id: 1
          },
          status: {
            type: "int32",
            id: 2
          },
          degree: {
            type: "string",
            id: 3
          },
          hasMaintain: {
            type: "bool",
            id: 4
          },
          isPartionLost: {
            type: "bool",
            id: 5
          },
          isBodyAffected: {
            type: "bool",
            id: 6
          },
          isCornerAffected: {
            type: "bool",
            id: 7
          },
          isHandlerAffected: {
            type: "bool",
            id: 8
          },
          isInsideAffected: {
            type: "bool",
            id: 9
          },
          isHardwareAffected: {
            type: "bool",
            id: 10
          },
          itemList: {
            rule: "repeated",
            type: "TSOPNewOrOldDetailItem",
            id: 11
          },
          errorCode: {
            type: "int32",
            id: 12
          },
          errorMsg: {
            type: "string",
            id: 13
          }
        }
      },
      TSOPApiWalletListRequest: {
        fields: {}
      },
      TSOPApiWalletListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          apiWalletList: {
            rule: "repeated",
            type: "TSOPApiWalletItem",
            id: 3
          }
        },
        nested: {
          TSOPApiWalletItem: {
            fields: {
              recordId: {
                type: "uint32",
                id: 1
              },
              apiKind: {
                type: "APIKind",
                id: 2
              },
              category: {
                type: "string",
                id: 3
              },
              totalUsed: {
                type: "int32",
                id: 4
              },
              balance: {
                type: "int64",
                id: 5
              },
              expiredAt: {
                type: "string",
                id: 6
              },
              categoryID: {
                type: "int64",
                id: 7
              },
              uid: {
                type: "string",
                id: 8
              },
              pkgType: {
                type: "PackageType",
                id: 9
              }
            }
          }
        }
      },
      TSOPApiWalletDetailRequest: {
        fields: {
          apiKind: {
            type: "APIKind",
            id: 1
          },
          kindId: {
            type: "int32",
            id: 2
          }
        }
      },
      TSOPApiWalletDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          detailList: {
            rule: "repeated",
            type: "DetailItem",
            id: 3
          }
        },
        nested: {
          DetailItem: {
            fields: {
              pkgType: {
                type: "PackageType",
                id: 1
              },
              balance: {
                type: "int32",
                id: 2
              },
              expiredAt: {
                type: "string",
                id: 3
              }
            }
          }
        }
      },
      TSOPApiWalletBalanceListRequest: {
        fields: {}
      },
      TSOPApiWalletBalanceListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          apiWalletBalanceList: {
            rule: "repeated",
            type: "TSOPApiWalletBalanceItem",
            id: 3
          }
        },
        nested: {
          TSOPApiWalletBalanceItem: {
            fields: {
              recordId: {
                type: "uint32",
                id: 1
              },
              apiKind: {
                type: "APIKind",
                id: 2
              },
              apiName: {
                type: "string",
                id: 3
              },
              category: {
                type: "string",
                id: 4
              },
              totalUsed: {
                type: "int32",
                id: 5
              },
              totalPay: {
                type: "int32",
                id: 6
              },
              unitPrice: {
                type: "int32",
                id: 7
              }
            }
          }
        }
      },
      TSOPAccountBalanceListRequest: {
        fields: {
          pageSize: {
            type: "uint32",
            id: 1
          },
          pageNum: {
            type: "uint32",
            id: 2
          }
        }
      },
      TSOPAccountBalanceListResponse: {
        fields: {
          errorCode: {
            type: "uint32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          accountBalanceList: {
            rule: "repeated",
            type: "AccountBalanceItem",
            id: 3
          },
          totalCount: {
            type: "int64",
            id: 4
          }
        },
        nested: {
          AccountBalanceItem: {
            fields: {
              username: {
                type: "string",
                id: 1
              },
              event: {
                type: "string",
                id: 2
              },
              amount: {
                type: "float",
                id: 3
              },
              balance: {
                type: "float",
                id: 4
              },
              serialNum: {
                type: "string",
                id: 5
              },
              payTime: {
                type: "string",
                id: 6
              }
            }
          }
        }
      },
      TSOPAccountTransactionListRequest: {
        fields: {
          pageSize: {
            type: "uint32",
            id: 1
          },
          pageNum: {
            type: "uint32",
            id: 2
          }
        }
      },
      TSOPAccountTransactionListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          accountTransactionList: {
            rule: "repeated",
            type: "TSOPAccountTransactionItem",
            id: 3
          },
          totalCount: {
            type: "int64",
            id: 4
          }
        },
        nested: {
          TSOPAccountTransactionItem: {
            fields: {
              ID: {
                type: "string",
                id: 1
              },
              payTime: {
                type: "string",
                id: 2
              },
              amount: {
                type: "float",
                id: 3
              },
              method: {
                type: "string",
                id: 4
              },
              transType: {
                type: "string",
                id: 5
              },
              serialNum: {
                type: "string",
                id: 6
              },
              balance: {
                type: "float",
                id: 7
              },
              orderId: {
                type: "string",
                id: 8
              }
            }
          }
        }
      },
      TSOPOrderDetailPackageItem: {
        fields: {
          productName: {
            type: "string",
            id: 1
          },
          packageType: {
            type: "PackageType",
            id: 2
          },
          kindName: {
            type: "string",
            id: 3
          },
          quantity: {
            type: "int32",
            id: 4
          },
          ValidPeriod: {
            type: "int32",
            id: 5
          },
          price: {
            type: "float",
            id: 6
          }
        }
      },
      TSOPApiOrderDetailRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSOPApiOrderDetailResponse: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          createTime: {
            type: "string",
            id: 2
          },
          payAmount: {
            type: "float",
            id: 3
          },
          orderStatus: {
            type: "string",
            id: 4
          },
          payMethod: {
            type: "string",
            id: 5
          },
          payTime: {
            type: "string",
            id: 6
          },
          packageInfo: {
            type: "TSOPOrderDetailPackageItem",
            id: 7
          },
          errorCode: {
            type: "uint32",
            id: 8
          },
          errorMsg: {
            type: "string",
            id: 9
          }
        }
      },
      TSOPStatisticItem: {
        fields: {
          status: {
            type: "string",
            id: 1
          },
          date: {
            type: "string",
            id: 2
          },
          count: {
            type: "int64",
            id: 3
          }
        }
      },
      TSOPHomeCallStatisticRequest: {
        fields: {}
      },
      TSOPHomeCallStatisticResponse: {
        fields: {
          appraisalToday: {
            type: "int64",
            id: 1
          },
          classifyToday: {
            type: "int64",
            id: 2
          },
          newOrOldToday: {
            type: "int64",
            id: 3
          },
          appraisal: {
            rule: "repeated",
            type: "TSOPStatisticItem",
            id: 4
          },
          classify: {
            rule: "repeated",
            type: "TSOPStatisticItem",
            id: 5
          },
          newOrOld: {
            rule: "repeated",
            type: "TSOPStatisticItem",
            id: 6
          },
          appraisalRate: {
            rule: "repeated",
            type: "Appraisal",
            id: 7
          },
          errorCode: {
            type: "uint32",
            id: 8
          },
          errorMsg: {
            type: "string",
            id: 9
          },
          CCIC: {
            rule: "repeated",
            type: "TSOPStatisticItem",
            id: 10
          },
          CCICToday: {
            type: "int64",
            id: 11
          },
          insurance: {
            rule: "repeated",
            type: "TSOPStatisticItem",
            id: 12
          },
          insuranceToday: {
            type: "int64",
            id: 13
          },
          psVerify: {
            rule: "repeated",
            type: "TSOPStatisticItem",
            id: 14
          },
          psVerifyToday: {
            type: "int64",
            id: 15
          }
        },
        nested: {
          Appraisal: {
            fields: {
              category: {
                type: "string",
                id: 1
              },
              count: {
                type: "int64",
                id: 2
              },
              percent: {
                type: "float",
                id: 3
              }
            }
          }
        }
      },
      TSOPDayEnum: {
        values: {
          SEVEN_DAY: 0,
          TODAY: 1,
          YESTERDAY: 2,
          BEFORE_YESTERDAY: 3,
          YEAR_TO_TODAY: 4,
          FIF_DAY: 5,
          THIRTY_DAY: 6,
          SIXTY_DAY: 7,
          CUSTOM: 8
        }
      },
      TSOPCallStatisticRequest: {
        fields: {
          day: {
            type: "TSOPDayEnum",
            id: 1
          },
          start: {
            type: "int64",
            id: 2
          },
          end: {
            type: "int64",
            id: 3
          }
        }
      },
      TSOPCallStatisticResponse: {
        fields: {
          appraisal: {
            rule: "repeated",
            type: "TSOPStatisticItem",
            id: 1
          },
          classify: {
            rule: "repeated",
            type: "TSOPStatisticItem",
            id: 2
          },
          newOrOld: {
            rule: "repeated",
            type: "TSOPStatisticItem",
            id: 3
          },
          insureAppraisal: {
            rule: "repeated",
            type: "TSOPStatisticItem",
            id: 4
          },
          psVerify: {
            rule: "repeated",
            type: "TSOPStatisticItem",
            id: 5
          },
          appraisalRate: {
            rule: "repeated",
            type: "Appraisal",
            id: 6
          },
          errorCode: {
            type: "uint32",
            id: 7
          },
          errorMsg: {
            type: "string",
            id: 8
          }
        },
        nested: {
          Appraisal: {
            fields: {
              category: {
                type: "string",
                id: 1
              },
              count: {
                type: "int64",
                id: 2
              },
              percent: {
                type: "float",
                id: 3
              }
            }
          }
        }
      },
      TSOPHomeStatisticRequest: {
        fields: {}
      },
      TSOPHomeStatisticResponse: {
        fields: {
          appraisalToday: {
            type: "int64",
            id: 1
          },
          classifyToday: {
            type: "int64",
            id: 2
          },
          newOrOldToday: {
            type: "int64",
            id: 3
          },
          appraisalAll: {
            rule: "repeated",
            type: "int64",
            id: 4
          },
          appraisalSuccess: {
            rule: "repeated",
            type: "int64",
            id: 5
          },
          appraisalFailed: {
            rule: "repeated",
            type: "int64",
            id: 6
          },
          classifyAll: {
            rule: "repeated",
            type: "int64",
            id: 7
          },
          classifySuccess: {
            rule: "repeated",
            type: "int64",
            id: 8
          },
          classifyFailed: {
            rule: "repeated",
            type: "int64",
            id: 9
          },
          newOrOldAll: {
            rule: "repeated",
            type: "int64",
            id: 10
          },
          newOrOldSuccess: {
            rule: "repeated",
            type: "int64",
            id: 11
          },
          newOrOldFailed: {
            rule: "repeated",
            type: "int64",
            id: 12
          },
          date: {
            rule: "repeated",
            type: "string",
            id: 13
          },
          appraisalRate: {
            rule: "repeated",
            type: "AppraisalItem",
            id: 14
          }
        },
        nested: {
          AppraisalItem: {
            fields: {
              value: {
                type: "int64",
                id: 1
              },
              name: {
                type: "string",
                id: 2
              }
            }
          }
        }
      },
      TSOPServiceStatisticsRequest: {
        fields: {
          day: {
            type: "string",
            id: 1
          }
        }
      },
      TSOPServiceStatisticsResponse: {
        fields: {
          appraisalAll: {
            rule: "repeated",
            type: "int64",
            id: 1
          },
          appraisalSuccess: {
            rule: "repeated",
            type: "int64",
            id: 2
          },
          appraisalFailed: {
            rule: "repeated",
            type: "int64",
            id: 3
          },
          classifyAll: {
            rule: "repeated",
            type: "int64",
            id: 4
          },
          classifySuccess: {
            rule: "repeated",
            type: "int64",
            id: 5
          },
          classifyFailed: {
            rule: "repeated",
            type: "int64",
            id: 6
          },
          newOrOldAll: {
            rule: "repeated",
            type: "int64",
            id: 7
          },
          newOrOldSuccess: {
            rule: "repeated",
            type: "int64",
            id: 8
          },
          newOrOldFailed: {
            rule: "repeated",
            type: "int64",
            id: 9
          },
          date: {
            rule: "repeated",
            type: "string",
            id: 10
          },
          appraisalRate: {
            rule: "repeated",
            type: "AppraisalItem",
            id: 11
          }
        },
        nested: {
          AppraisalItem: {
            fields: {
              value: {
                type: "int64",
                id: 1
              },
              name: {
                type: "string",
                id: 2
              }
            }
          }
        }
      },
      TSOPCallDetailRequest: {
        fields: {
          apiKind: {
            type: "string",
            id: 1
          },
          status: {
            type: "int32",
            id: 2
          },
          startTime: {
            type: "int64",
            id: 3
          },
          endTime: {
            type: "int64",
            id: 4
          },
          pageSize: {
            type: "uint32",
            id: 5
          },
          pageNum: {
            type: "uint32",
            id: 6
          },
          categoryID: {
            type: "uint32",
            id: 7
          }
        }
      },
      TSOPCallDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          myRecordList: {
            rule: "repeated",
            type: "MyRecordItem",
            id: 3
          },
          totalCount: {
            type: "int64",
            id: 4
          }
        },
        nested: {
          MyRecordItem: {
            fields: {
              ID: {
                type: "uint32",
                id: 1
              },
              time: {
                type: "string",
                id: 2
              },
              apiCategory: {
                type: "string",
                id: 3
              },
              kind: {
                type: "string",
                id: 4
              },
              brand: {
                type: "string",
                id: 5
              },
              series: {
                type: "string",
                id: 6
              },
              status: {
                type: "int32",
                id: 7
              },
              requestID: {
                type: "string",
                id: 8
              }
            }
          }
        }
      },
      PackageType: {
        values: {
          PkgTypeAny: 0,
          PkgTypeMonthly: 1,
          PkgTypeLimited: 2
        }
      },
      PayMethod: {
        values: {
          MethodAny: 0,
          MethodWechat: 1,
          MethodAlipay: 2,
          MethodPlatformDeduction: 3,
          MethodPlatformPay: 4
        }
      },
      TransactionType: {
        values: {
          TransTypeAny: 0,
          TransTypeDeduction: 1,
          TransTypeRecharge: 2,
          TransTypePurchase: 3
        }
      },
      APIKind: {
        values: {
          APIKindAny: 0,
          APIKindAppraisal: 1,
          APIKindNewOrOld: 2,
          APIKindClassify: 3,
          APIKindCCICAppraisal: 4,
          APIKindInsureAppraisal: 5,
          APIKindPsVerify: 6
        }
      },
      Action: {
        values: {
          ActionAny: 0,
          ActionCreate: 1,
          ActionEdit: 2
        }
      },
      TSOPAppraisalType: {
        values: {
          TSOPAType_Any: 0,
          TSOPAType_AI: 1,
          TSOPAType_CCIC: 2,
          TSOPAtype_Manual: 3
        }
      },
      TSOPAPIOrderStatus: {
        values: {
          OrderStatusAny: 0,
          OrderStatusUnpay: 1,
          OrderStatusPaid: 2,
          OrderStatusWaitToPay: 3,
          OrderStatusTimeOut: 4
        }
      },
      AppraisalReportType: {
        values: {
          APPRAISAL_REPORT_TYPE_DEFAULT: 0,
          APPRAISAL_REPORT_TYPE_WOOD: 1
        }
      },
      ManualResult: {
        values: {
          MANUAL_RESULT_DEFAULT: 0,
          MANUAL_RESULT_TRUE: 1,
          MANUAL_RESULT_FALSE: 2,
          MANUAL_RESULT_UNKNOWN: 3
        }
      },
      AppraisalType: {
        values: {
          APPRAISAL_TYPE_DEFAULT: 0,
          APPRAISAL_TYPE_AI: 1,
          APPRAISAL_TYPE_MANUAL: 2
        }
      },
      AppraisalKindItem: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          }
        }
      },
      AppraisalBrandItem: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          }
        }
      },
      AppraisalSeriesItem: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          }
        }
      },
      PointItem: {
        fields: {
          pointID: {
            type: "int32",
            id: 1
          },
          pointName: {
            type: "string",
            id: 2
          },
          hierarchy: {
            type: "string",
            id: 3
          },
          kindID: {
            type: "int32",
            id: 4
          },
          kindName: {
            type: "string",
            id: 5
          },
          brandID: {
            type: "int32",
            id: 6
          },
          brandName: {
            type: "string",
            id: 7
          },
          seriesID: {
            type: "int32",
            id: 8
          },
          seriesName: {
            type: "string",
            id: 9
          },
          sequence: {
            type: "int32",
            id: 10
          },
          important: {
            type: "string",
            id: 11
          },
          status: {
            type: "string",
            id: 12
          },
          exampleImage: {
            type: "string",
            id: 13
          },
          must: {
            type: "int32",
            id: 14
          }
        }
      },
      TSAdminAppraisalKindListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          kindList: {
            rule: "repeated",
            type: "AppraisalKindItem",
            id: 3
          },
          totalCount: {
            type: "int32",
            id: 4
          }
        }
      },
      TSAdminAppraisalBrandListRequest: {
        fields: {
          kindID: {
            type: "int32",
            id: 1
          }
        }
      },
      TSAdminAppraisalBrandListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          brandList: {
            rule: "repeated",
            type: "AppraisalBrandItem",
            id: 3
          },
          totalCount: {
            type: "int32",
            id: 4
          }
        }
      },
      TSAdminAppraisalSeriesListRequest: {
        fields: {
          brandID: {
            type: "int32",
            id: 1
          }
        }
      },
      TSAdminAppraisalSeriesListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          seriesList: {
            rule: "repeated",
            type: "AppraisalSeriesItem",
            id: 3
          },
          totalCount: {
            type: "int32",
            id: 4
          }
        }
      },
      TSAdminPointListRequest: {
        fields: {
          pointName: {
            type: "string",
            id: 1
          },
          hierarchy: {
            type: "string",
            id: 2
          },
          kindID: {
            type: "int32",
            id: 3
          },
          brandID: {
            type: "int32",
            id: 4
          },
          seriesID: {
            type: "int32",
            id: 5
          },
          important: {
            type: "string",
            id: 6
          },
          status: {
            type: "string",
            id: 7
          },
          pageNum: {
            type: "int32",
            id: 8
          },
          pageSize: {
            type: "int32",
            id: 9
          },
          pointID: {
            type: "int32",
            id: 10
          },
          must: {
            type: "int32",
            id: 11
          }
        }
      },
      TSAdminPointListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          totalCount: {
            type: "int32",
            id: 3
          },
          pointList: {
            rule: "repeated",
            type: "PointItem",
            id: 4
          }
        }
      },
      TSOPRequiredNumItem: {
        fields: {
          brandName: {
            type: "string",
            id: 1
          },
          importantPoint: {
            type: "string",
            id: 2
          },
          leastNum: {
            type: "int32",
            id: 3
          },
          seriesName: {
            type: "string",
            id: 4
          },
          kindName: {
            type: "string",
            id: 5
          }
        }
      },
      TSOPAppraisalPointRequiredNumRequest: {
        fields: {
          hierarchy: {
            type: "int32",
            id: 1
          },
          categoryId: {
            type: "int32",
            id: 2
          },
          pageNum: {
            type: "int32",
            id: 3
          },
          pageSize: {
            type: "int32",
            id: 4
          },
          appraisalType: {
            type: "TSOPAppraisalType",
            id: 5
          }
        }
      },
      TSOPAppraisalPointRequiredNumResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          pointList: {
            rule: "repeated",
            type: "TSOPRequiredNumItem",
            id: 3
          },
          totalCount: {
            type: "int64",
            id: 4
          }
        }
      },
      TSOPAdminPointListV2Request: {
        fields: {
          pointName: {
            type: "string",
            id: 1
          },
          hierarchy: {
            type: "string",
            id: 2
          },
          kindID: {
            type: "int32",
            id: 3
          },
          brandID: {
            type: "int32",
            id: 4
          },
          seriesID: {
            type: "int32",
            id: 5
          },
          important: {
            type: "string",
            id: 6
          },
          status: {
            type: "string",
            id: 7
          },
          pageNum: {
            type: "int32",
            id: 8
          },
          pageSize: {
            type: "int32",
            id: 9
          },
          pointID: {
            type: "int32",
            id: 10
          },
          must: {
            type: "int32",
            id: 11
          }
        }
      },
      TSOPAdminPointListV2Response: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          totalCount: {
            type: "int32",
            id: 3
          },
          pointList: {
            rule: "repeated",
            type: "PointItemV2",
            id: 4
          }
        }
      },
      PointItemV2: {
        fields: {
          pointID: {
            type: "int32",
            id: 1
          },
          pointName: {
            type: "string",
            id: 2
          },
          hierarchy: {
            type: "string",
            id: 3
          },
          kindID: {
            type: "int32",
            id: 4
          },
          kindName: {
            type: "string",
            id: 5
          },
          brandID: {
            type: "int32",
            id: 6
          },
          brandName: {
            type: "string",
            id: 7
          },
          seriesID: {
            type: "int32",
            id: 8
          },
          seriesName: {
            type: "string",
            id: 9
          },
          sequence: {
            type: "int32",
            id: 10
          },
          important: {
            type: "string",
            id: 11
          },
          status: {
            type: "string",
            id: 12
          },
          exampleImage: {
            type: "string",
            id: 13
          },
          must: {
            type: "int32",
            id: 14
          },
          mustNum: {
            type: "int32",
            id: 15
          }
        }
      },
      TSAdminPointListV2Request: {
        fields: {
          pointName: {
            type: "string",
            id: 1
          },
          hierarchy: {
            type: "string",
            id: 2
          },
          kindID: {
            type: "int32",
            id: 3
          },
          brandID: {
            type: "int32",
            id: 4
          },
          seriesID: {
            type: "int32",
            id: 5
          },
          important: {
            type: "string",
            id: 6
          },
          status: {
            type: "string",
            id: 7
          },
          pageNum: {
            type: "int32",
            id: 8
          },
          pageSize: {
            type: "int32",
            id: 9
          },
          pointID: {
            type: "int32",
            id: 10
          },
          must: {
            type: "int32",
            id: 11
          }
        }
      },
      TSAdminPointListV2Response: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          totalCount: {
            type: "int32",
            id: 3
          },
          pointList: {
            rule: "repeated",
            type: "PointItem",
            id: 4
          }
        }
      },
      TSAdminManualPointDetailRequest: {
        fields: {
          pointID: {
            type: "int32",
            id: 1
          }
        }
      },
      TSAdminManualPointDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          pointID: {
            type: "int32",
            id: 3
          },
          pointName: {
            type: "string",
            id: 4
          },
          hierarchy: {
            type: "string",
            id: 5
          },
          kindID: {
            type: "int32",
            id: 6
          },
          kindName: {
            type: "string",
            id: 7
          },
          brandID: {
            type: "int32",
            id: 8
          },
          brandName: {
            type: "string",
            id: 9
          },
          seriesID: {
            type: "int32",
            id: 10
          },
          seriesName: {
            type: "string",
            id: 11
          },
          sequence: {
            type: "int32",
            id: 12
          },
          important: {
            type: "string",
            id: 13
          },
          status: {
            type: "string",
            id: 14
          },
          stickFigureUrl: {
            type: "string",
            id: 15
          },
          bigStickFigureUrl: {
            type: "string",
            id: 16
          },
          exampleImage: {
            type: "string",
            id: 17
          },
          must: {
            type: "int32",
            id: 18
          }
        }
      },
      TSOPDocRequest: {
        fields: {
          api: {
            type: "string",
            id: 1
          },
          category: {
            type: "string",
            id: 2
          },
          language: {
            type: "string",
            id: 3
          }
        }
      },
      TSOPDocResponse: {
        fields: {
          errorCode: {
            type: "uint32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          content: {
            type: "string",
            id: 3
          }
        }
      },
      TSOPAskRequest: {
        fields: {
          phoneNum: {
            type: "string",
            id: 1
          },
          email: {
            type: "string",
            id: 2
          },
          question: {
            type: "string",
            id: 3
          },
          company: {
            type: "string",
            id: 4
          },
          askCategory: {
            type: "AskEnum",
            id: 5
          }
        },
        nested: {
          AskEnum: {
            values: {
              All: 0,
              PRE_SALE: 1,
              POST_SALE: 2
            }
          }
        }
      },
      TSOPAskResponse: {
        fields: {
          errorCode: {
            type: "uint32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSOPAppraisalReportSAItem: {
        fields: {
          SAID: {
            type: "string",
            id: 1
          },
          image: {
            type: "string",
            id: 2
          },
          pointName: {
            type: "string",
            id: 3
          },
          grade: {
            type: "string",
            id: 4
          },
          detection: {
            type: "bool",
            id: 5
          },
          originalBox: {
            type: "TSOPAppraisalBox",
            id: 6
          },
          detectionBox: {
            type: "TSOPAppraisalBox",
            id: 7
          },
          showFake: {
            type: "bool",
            id: 8
          },
          fakePoints: {
            rule: "repeated",
            type: "TSOPAppraisalBox",
            id: 9
          },
          croppedImageURL: {
            type: "string",
            id: 10
          },
          description: {
            type: "string",
            id: 11
          }
        }
      },
      TSOPAppraisalBox: {
        fields: {
          x: {
            type: "string",
            id: 1
          },
          y: {
            type: "string",
            id: 2
          },
          width: {
            type: "string",
            id: 3
          },
          height: {
            type: "string",
            id: 4
          },
          radius: {
            type: "string",
            id: 5
          }
        }
      },
      TSOPAppraisalReportRequest: {
        fields: {
          OAID: {
            type: "string",
            id: 1
          }
        }
      },
      TSOPAppraisalReportResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          exteriorUrl: {
            type: "string",
            id: 3
          },
          orderNo: {
            type: "string",
            id: 4
          },
          OAID: {
            type: "string",
            id: 5
          },
          genuine: {
            type: "string",
            id: 6
          },
          hierarchy: {
            type: "string",
            id: 7
          },
          kindID: {
            type: "int32",
            id: 8
          },
          kindName: {
            type: "string",
            id: 9
          },
          brandID: {
            type: "int32",
            id: 10
          },
          brandName: {
            type: "string",
            id: 11
          },
          seriesID: {
            type: "int32",
            id: 12
          },
          seriesName: {
            type: "string",
            id: 13
          },
          appraisalTime: {
            type: "string",
            id: 14
          },
          description: {
            type: "string",
            id: 15
          },
          grade: {
            type: "string",
            id: 16
          },
          SARecordList: {
            rule: "repeated",
            type: "TSOPAppraisalReportSAItem",
            id: 17
          },
          originalBox: {
            type: "TSOPAppraisalBox",
            id: 18
          },
          detectionBox: {
            type: "TSOPAppraisalBox",
            id: 19
          },
          reportImageURL: {
            type: "string",
            id: 20
          },
          mappingResult: {
            type: "string",
            id: 21
          },
          familyAndGenus: {
            type: "string",
            id: 22
          },
          material: {
            type: "string",
            id: 23
          },
          reportType: {
            type: "AppraisalReportType",
            id: 24
          },
          manualResult: {
            type: "ManualResult",
            id: 25
          },
          appraisalType: {
            type: "AppraisalType",
            id: 26
          }
        }
      },
      TSOPLoginRequest: {
        fields: {
          username: {
            type: "string",
            id: 1
          },
          password: {
            type: "string",
            id: 2
          }
        }
      },
      TSOPLoginResponse: {
        fields: {
          errorCode: {
            type: "uint32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          token: {
            type: "string",
            id: 3
          },
          hasLogin: {
            type: "bool",
            id: 4
          }
        }
      },
      TSOPRegisterRequest: {
        fields: {
          companyName: {
            type: "string",
            id: 1
          },
          appName: {
            type: "string",
            id: 2
          },
          username: {
            type: "string",
            id: 3
          },
          password: {
            type: "string",
            id: 4
          },
          contactName: {
            type: "string",
            id: 6
          },
          contactPhone: {
            type: "string",
            id: 7
          }
        }
      },
      TSOPRegisterResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSOPChangePasswordRequest: {
        fields: {
          oldPassword: {
            type: "string",
            id: 1
          },
          newPassword: {
            type: "string",
            id: 2
          },
          confirmPassword: {
            type: "string",
            id: 3
          }
        }
      },
      TSOPChangePasswordResponse: {
        fields: {
          errorCode: {
            type: "uint32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSOPUserInfoRequest: {
        fields: {}
      },
      TSOPUserInfoResponse: {
        fields: {
          errorCode: {
            type: "uint32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          username: {
            type: "string",
            id: 3
          },
          enabled: {
            type: "bool",
            id: 4
          },
          password: {
            type: "string",
            id: 5
          },
          appName: {
            type: "string",
            id: 6
          },
          apiKey: {
            type: "string",
            id: 7
          },
          apiSecret: {
            type: "string",
            id: 8
          },
          companyName: {
            type: "string",
            id: 9
          },
          contactName: {
            type: "string",
            id: 10
          },
          contactPhone: {
            type: "string",
            id: 11
          },
          contactEmail: {
            type: "string",
            id: 12
          },
          contactWechat: {
            type: "string",
            id: 13
          },
          techName: {
            type: "string",
            id: 14
          },
          techPhone: {
            type: "string",
            id: 15
          },
          techEmail: {
            type: "string",
            id: 16
          },
          techWechat: {
            type: "string",
            id: 17
          },
          balance: {
            type: "float",
            id: 18
          },
          notifyUrl: {
            type: "string",
            id: 19
          }
        }
      },
      TSOPContactRequest: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          phone: {
            type: "string",
            id: 2
          },
          email: {
            type: "string",
            id: 3
          },
          wechat: {
            type: "string",
            id: 4
          },
          isTechnician: {
            type: "bool",
            id: 5
          }
        }
      },
      TSOPContactResponse: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          phone: {
            type: "string",
            id: 2
          },
          email: {
            type: "string",
            id: 3
          },
          wechat: {
            type: "string",
            id: 4
          },
          errorCode: {
            type: "int32",
            id: 5
          },
          errorMsg: {
            type: "string",
            id: 6
          }
        }
      },
      TSOPUserInfoModifyRequest: {
        fields: {
          companyName: {
            type: "string",
            id: 1
          }
        }
      },
      TSOPUserInfoModifyResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSOPNotifyUrlModifyRequest: {
        fields: {
          notifyUrl: {
            type: "string",
            id: 2
          }
        }
      },
      TSOPNotifyUrlModifyResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSOPTradeResponse: {
        fields: {
          tradeNo: {
            type: "string",
            id: 1
          },
          wechatUrl: {
            type: "string",
            id: 2
          },
          alipayUrl: {
            type: "string",
            id: 3
          }
        }
      },
      TSOPAccountRechargeRequest: {
        fields: {
          amount: {
            type: "float",
            id: 1
          },
          payMethod: {
            type: "PayMethod",
            id: 2
          }
        }
      },
      TSOPAccountRechargeResponse: {
        fields: {
          errorCode: {
            type: "uint32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          tradeResponse: {
            type: "TSOPTradeResponse",
            id: 3
          }
        }
      },
      TSOPQueryOrderRequest: {
        fields: {
          tradeNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSOPQueryOrderResponse: {
        fields: {
          Paid: {
            type: "bool",
            id: 1
          },
          errorCode: {
            type: "uint32",
            id: 2
          },
          errorMsg: {
            type: "string",
            id: 3
          }
        }
      },
      TSOPBuyPackageListRequest: {
        fields: {
          apiKind: {
            type: "APIKind",
            id: 1
          },
          pkgType: {
            type: "PackageType",
            id: 2
          },
          category: {
            type: "string",
            id: 3
          },
          categoryID: {
            type: "int64",
            id: 4
          }
        }
      },
      TSOPBuyPackageListResponse: {
        fields: {
          errorCode: {
            type: "uint32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          buyPackageList: {
            rule: "repeated",
            type: "PackageItem",
            id: 3
          },
          totalCount: {
            type: "int64",
            id: 4
          }
        },
        nested: {
          PackageItem: {
            fields: {
              packageId: {
                type: "uint32",
                id: 1
              },
              price: {
                type: "float",
                id: 2
              },
              originPrice: {
                type: "float",
                id: 3
              },
              description: {
                type: "string",
                id: 4
              },
              quantity: {
                type: "int64",
                id: 5
              },
              validateMonth: {
                type: "int32",
                id: 6
              }
            }
          }
        }
      },
      TSOPMakeOrderRequest: {
        fields: {
          packageId: {
            type: "uint32",
            id: 1
          },
          payMethod: {
            type: "PayMethod",
            id: 2
          }
        }
      },
      TSOPMakeOrderResponse: {
        fields: {
          errorCode: {
            type: "uint32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          tradeResponse: {
            type: "TSOPTradeResponse",
            id: 3
          }
        }
      },
      TSOPQueryOrderStatusRequest: {
        fields: {
          tradeNo: {
            type: "string",
            id: 1
          },
          orderType: {
            type: "TransactionType",
            id: 2
          }
        }
      },
      TSOPQueryOrderStatusReponse: {
        fields: {
          errorCode: {
            type: "uint32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderStatus: {
            type: "TSOPAPIOrderStatus",
            id: 3
          }
        }
      }
    }
  }
});

export { $root as default };
